export default {
  install(Vue, options) {
    // 异步事件包装
    Vue.prototype.$awaitWrap = function (promise) {
      if (promise instanceof Promise) {
        return promise
          .then((data) => {
            return [null, data];
          })
          .catch((err) => {
            console.log(err);
            return [err, null];
          });
      } else {
        console.error('param is not a promise');
        return [null, promise];
      }
    };

    // 异步事件包装
    Vue.prototype.$removeSpace = function (str) {
      let resultStr = '';
      if (str) {
        resultStr = str
          .replace(/\r\n/g, '')
          .replace(/\n/g, '')
          .replace(/\s/g, '');
      }
      return resultStr;
    };

    // 获取文件名后缀
    Vue.prototype.$getFileSuffix = function (fileName) {
      const fileNameArr = fileName.split('.');
      if (fileNameArr.length > 1) {
        return fileNameArr[fileNameArr.length - 1];
      } else {
        return '';
      }
    };

    // 获取文件名
    Vue.prototype.$getFileNameFromResponse = function (response) {
      let filename = '';
      const contentDisposition = decodeURIComponent(
        response.headers['content-disposition']
      );
      const str = contentDisposition.split(';')[1];
      filename = str.split('=')[1];
      return filename;
    };

    // 首字符大写
    Vue.prototype.$upperFirstChar = function (str) {
      if (str.length > 0) {
        return str.replace(str[0], str[0].toUpperCase());
      } else {
        return str;
      }
    };

    // 检查数据是否有重复值
    Vue.prototype.$arrRepeat = function (arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr.indexOf(arr[i]) != arr.lastIndexOf(arr[i])) {
          return true;
        }
      };
      return false;
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/function/index.js